import { Group, Table, Text, Tooltip } from "@mantine/core";

import ActivityActor from "./ActivityActor";
import ActivityCategoryIcon from "./ActivityCategoryIcon";
import {
	toActionLabel,
	toDetailsSummary,
	toExactTime,
	toRelativeTime,
} from "../../utils/activity";

import type { ActivityLogEntry } from "../../services/api";

interface ActivityTableProps {
	logs: ActivityLogEntry[];
}

function ActivityTable({ logs }: ActivityTableProps) {
	return (
		<Table.ScrollContainer minWidth={800}>
			<Table
				striped
				highlightOnHover>
				<Table.Thead>
					<Table.Tr>
						<Table.Th>Time</Table.Th>
						<Table.Th>Action</Table.Th>
						<Table.Th>Resource</Table.Th>
						<Table.Th>Actor</Table.Th>
						<Table.Th>Details</Table.Th>
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>
					{logs.map((entry) => (
						<Table.Tr key={entry.id}>
							<Table.Td>
								<Tooltip label={toExactTime(entry.createdAt)}>
									<Text
										component="time"
										dateTime={entry.createdAt}
										size="sm"
										style={{ whiteSpace: "nowrap" }}>
										{toRelativeTime(entry.createdAt)}
									</Text>
								</Tooltip>
							</Table.Td>
							<Table.Td>
								<Group
									gap="sm"
									wrap="nowrap">
									<ActivityCategoryIcon category={entry.category} />
									<Text size="sm">{toActionLabel(entry.action)}</Text>
								</Group>
							</Table.Td>
							<Table.Td>
								<Text size="sm">{entry.resource || "-"}</Text>
							</Table.Td>
							<Table.Td>
								<ActivityActor
									actorName={entry.actorName}
									actorType={entry.actorType}
								/>
							</Table.Td>
							<Table.Td>
								<Text
									size="sm"
									c="dimmed">
									{toDetailsSummary(entry.details) || "-"}
								</Text>
							</Table.Td>
						</Table.Tr>
					))}
				</Table.Tbody>
			</Table>
		</Table.ScrollContainer>
	);
}

export default ActivityTable;
